import api from './api'

export const reviewsService = {
  getAll: async (params = {}) => {
    const res = await api.get('/reviews', { params })
    return res.data
  },

  approve: async (id) => {
    const res = await api.patch(`/reviews/${id}/approve`)
    return res.data.data
  },

  reject: async (id) => {
    const res = await api.patch(`/reviews/${id}/reject`)
    return res.data.data
  },

  // Admin authors a review/testimonial (auto-approved)
  create: async (payload) => {
    // payload: { productId, authorName, rating, title?, content? }
    const res = await api.post('/reviews/admin', payload)
    return res.data.data
  },
}
